import {
    FormField,
    Input,
    InputField,
    SelectGeneric,
    useNumberInputRules
} from "@hosttools/frontend";
import type React from "react";
import {memo} from "react";
import {Controller, useForm} from "react-hook-form";

import {nearbyAmenitiesOptions} from "../constant";
import RowAction from "../RowAction";
import type {NearbyAmenityType} from "../type";

import {TableCell, TableRow} from "@/client/components/Table";

type Props = {
    item?: Partial<NearbyAmenityType>;
    index?: number;
    onChange: (item: NearbyAmenityType) => void;
    onCancel: () => void;
};

const Form: React.FC<Props> = ({item, onChange, onCancel}) => {
    const {
        control,
        register,
        handleSubmit,
        formState: {errors}
    } = useForm<NearbyAmenityType>({
        defaultValues: item ?? {
            attributeId: undefined,
            distance: undefined
        }
    });

    const inputNumberRules = useNumberInputRules({min: 0});

    return (
        <TableRow>
            <TableCell>
                <FormField error={errors?.attributeId?.message}>
                    <Controller
                        control={control}
                        name="attributeId"
                        render={({field}) => {
                            return (
                                <SelectGeneric
                                    options={nearbyAmenitiesOptions}
                                    placeholder="Select..."
                                    value={field.value}
                                    onChange={field.onChange}
                                />
                            );
                        }}
                        rules={{required: "Please select attribute."}}
                    />
                </FormField>
            </TableCell>
            <TableCell>
                <FormField error={errors?.distance?.message}>
                    <Input isRequired>
                        <InputField
                            id="distance"
                            placeholder="Distance...."
                            testID="distance"
                            type="number"
                            {...register("distance", {
                                ...inputNumberRules,
                                required: "Please enter distance."
                            })}
                        />
                    </Input>
                </FormField>
            </TableCell>
            <TableCell align="end">
                <RowAction onCancel={onCancel} onSubmit={handleSubmit(onChange)} />
            </TableCell>
        </TableRow>
    );
};

export default memo(Form);
